import "date-fns";
import React, { useState } from "react";
import {
  Formik,
  FormikActions,
  Form as FormikForm,
  Field,
  FormikProps,
} from "formik";
import { InjectedIntlProps, injectIntl, FormattedMessage } from "react-intl";
import TextInput from "../../text-input";
import Typography from "../../typography";
import InputErrorMessage from "../../input-error-message";

import messages from "../PageAddLeague.intl";
import { styled, makeStyles, createStyles } from "@material-ui/styles";
import { IStyledArguments } from "../../../types/styled-arguments";
import { required } from "../../form-utils";
import { Theme } from "@material-ui/core";
// import { ITeam } from "../../../types";
// import Select from "../../select";
// import Option from "../../select/option";
import {
  MuiPickersUtilsProvider,
  // KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import DateFnsUtils from "@date-io/date-fns";
import Button from "../../button";
import moment from "moment";
import {
  Select,
  FormControl,
  InputLabel,
  // FormHelperText
} from "@material-ui/core";
// import { Checkbox, FormControlLabel } from "@material-ui/core";

export interface IFormValues {
  location: string;
  date: string;
  time: string;
  homeTeam: string;
  awayTeam: string;
  local: boolean;
  playersSelected: string[];
  playersConfirmed: string[];
  status: string;
}

const Title = styled(({ children }) => (
  <Typography.H5 component="h2">{children}</Typography.H5>
))((props: IStyledArguments) => {
  const { md } = props.theme.breakpoints.values;

  return {
    marginBottom: 23,
    [`@media (max-width: ${md}px)`]: {
      marginBottom: 27,
    },
  };
});

const ImageHeader = styled("div")(({ theme }: IStyledArguments) => ({
  padding: theme.spacing(0, 1, 1, 1),
  width: "100%",
}));

interface IForm extends InjectedIntlProps {
  onSubmit: (arg: any) => void;
  location?: string;
  date?: string;
  time?: string;
  homeTeam?: any;
  awayTeam?: string;
  teams?: any;
  local?: boolean;
  playersSelected?: any;
  playersConfirmed?: any;
  status?: string;
  isHomeTeamLocal?: boolean;
}

const StyledForm = styled(FormikForm)(() => ({
  display: "flex",
  flexDirection: "column",
}));

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      // margin: theme.spacing(1),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      minWidth: 120,
    },
  })
);

// const useStylesInput = makeStyles((theme: Theme) => ({
//   root: {
//     "& input": {
//       // ...theme.typography.h5,
//       // backgroundColor: theme.palette.primary.dark,
//       // color: theme.palette.extra.default,
//       marginTop: 8
//     }
//   }
// }));

const NewTeamForm = ({
  onSubmit,
  location = "",
  // date = "",
  // time = "",
  homeTeam = "",
  awayTeam = "",
  teams,
  isHomeTeamLocal = false,
  intl,
}: IForm) => {
  // const [teamOption, setTeamOption] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<Date>(
    moment()
      .day("sunday")
      .isBefore(Date.now(), "day")
      ? moment()
          .day("sunday")
          .add(7, "day")
          .toDate()
      : moment()
          .day("sunday")
          .toDate()
  );

  const classes = useStyles();
  // const classesInput = useStylesInput();
  // const [selectedTime, setSelectedTime] = useState<Date>(
  //   new Date("2019-08-18T10:00:00")
  // );

  const [kindOfLeague, setKindOfLeague] = useState("");
  const [partsInAGame, setPartsInAGame] = useState();

  const handleDateChange = (date: Date) => {
    setSelectedDate(date);
  };
  const handleKindOfLeagueChange = (evt: any) => {
    console.log("handle change================", evt.target.value);
    // console.log(date);
    // setSelectedTime(date);
    setKindOfLeague(evt.target.value);
  };
  const handlePartsInAGameChange = (evt: any) => {
    console.log("handle change================");
    // console.log(date);
    // setSelectedTime(date);
    setPartsInAGame(evt.target.value);
  };

  // const handleLocal = (isLocal: boolean) => {
  //   console.log("local================");
  //   console.log(isLocal);
  //   setLocal(isLocal);
  // };

  return (
    <Formik
      initialValues={{
        location,
        date: `${moment(selectedDate).format("YYYY-MM-DD")}`,
        // time: `${moment(selectedTime).format("HH:mm")}`,
        homeTeam,
        awayTeam,
        teams,
        isHomeTeamLocal,
      }}
      onSubmit={(values: any, actions: FormikActions<any>) => {
        onSubmit(values);
        actions.setSubmitting(false);
      }}
      render={({
        errors,
        touched,
        // values,
        isValid,
        setFieldValue,
      }: FormikProps<any>) => {
        return (
          <>
            <ImageHeader>
              <svg
                height="80px"
                viewBox="-41 0 499 499.312"
                width="80px"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <linearGradient
                  id="a"
                  gradientUnits="userSpaceOnUse"
                  x1="208.156"
                  x2="208.156"
                  y1="499.312"
                  y2="-.0008"
                >
                  <stop offset="0" stop-color="#FF5722" />
                  <stop offset="1" stop-color="#0bb1d3" />
                </linearGradient>
                <path
                  d="m291.691406 243.488281c3.054688-10.207031 8.023438-19.824219 14.703125-28.167969l2.121094-2.648437c7.503906-9.390625 11.640625-21.183594 11.640625-33.191406 0-17.816407-8.839844-34.34375-23.671875-44.234375l-8.113281-5.390625-32.214844 19.328125v-17.871094h-15.984375v-8c0-13.234375-10.769531-24-24-24h-8v-8c0-13.234375-10.769531-24-24-24h-14.015625l24.574219-32.753906-34.558594-34.558594-34.558594 34.558594 24.542969 32.753906h-13.984375c-13.230469 0-24 10.765625-24 24v8h-8c-13.230469 0-24 10.765625-24 24v8h-16.015625v17.871094l-32.214844-19.328125-8.121094 5.402343c-14.824218 9.878907-23.664062 26.40625-23.664062 44.222657 0 12.015625 4.136719 23.808593 11.640625 33.191406l2.128906 2.65625c11.75 14.695313 18.230469 33.152344 18.230469 51.984375 0 4.414062-3.585938 8-8 8-4.417969 0-8-3.585938-8-8v-8h-16v8c0 13.230469 10.769531 24 24 24s24-10.769531 24-24c0-22.457031-7.726562-44.472656-21.746094-61.976562l-2.117187-2.648438c-5.25-6.566406-8.136719-14.816406-8.136719-23.207031 0-12.320313 6.0625-23.777344 16.222656-30.703125l31.777344 19.0625v22.433594c0 55 23.222656 107.34375 63.769531 144.328124-1.136719 15.34375-10.042969 28.902344-23.976562 35.878907l-7.785157 3.894531-.007812 28.9375h-7.984375c-13.230469 0-24 10.765625-24 24v25.472656c-9.289063 3.3125-16 12.109375-16 22.527344v24h216v-2.335938c7.777344 1.488282 15.777344 2.335938 23.984375 2.335938 70.574219 0 128-57.425781 128-128 0-69.382812-55.527344-125.921875-124.464844-127.824219zm-131.519531-220.863281 13.441406 13.4375-13.449219 17.914062-13.433593-17.914062zm179.984375 404.6875-19.457031-25.9375 6.394531-31.941406 40.101562-13.371094 32.738282 19.648438c-.738282 18.753906-6.050782 36.304687-14.929688 51.609374h-44.847656zm-106.03125 16 8.648438 30.304688c-15.640626-6.960938-29.402344-17.371094-40.289063-30.304688zm2.03125-16h-44.847656c-8.816406-15.183594-14.113282-32.585938-14.914063-51.175781l40.121094-20.066407 32.640625 13.058594 6.457031 32.246094zm52-168c10.527344 0 20.671875 1.558594 30.335938 4.289062l-29.976563 24.933594-30.535156-24.984375c9.617187-2.6875 19.710937-4.238281 30.175781-4.238281zm-47.519531 10.726562 39.519531 32.34375v32.929688l-25.199219 18.902344-33-13.199219-20.34375-40.695313c10.519531-12.808593 23.871094-23.136718 39.023438-30.28125zm-49.382813 45.359376 14.167969 28.335937-28.394531 14.195313c1.847656-15.34375 6.808594-29.722657 14.226562-42.53125zm73.734375 51.289062 23.167969-17.375 23.167969 17.375-5.71875 28.625h-34.890625zm112.785157-22.925781 8.679687-26.058594c6.460937 11.808594 10.765625 24.9375 12.605469 38.824219zm-2.59375-42.808594-13.351563 40.039063-40.222656 13.40625-25.449219-19.085938v-32.3125l39.574219-32.929688c15.371093 7.25 28.867187 17.816407 39.449219 30.882813zm-87.246094-152.175781c10.167968 6.933594 16.222656 18.375 16.222656 30.703125 0 8.398437-2.886719 16.640625-8.144531 23.207031l-2.121094 2.640625c-9.046875 11.3125-15.34375 24.601563-18.757813 38.640625-9.871093 1-19.367187 3.246094-28.457031 6.367188 6.289063-19.34375 9.480469-39.464844 9.480469-60.0625v-22.433594zm-159.761719-57.464844c0-4.417969 3.585937-8 8-8h48c4.417969 0 8 3.582031 8 8v8h-64zm-32 32c0-4.417969 3.585937-8 8-8h112c4.417969 0 8 3.582031 8 8v8h-128zm-16.015625 66.960938v-42.960938h160v42.960938c0 23.910156-4.710938 47.117187-13.894531 69.078124-25.480469 14.144532-45.617188 36.726563-56.683594 63.960938h-30.375c-37.558594-33.976562-59.046875-82.296875-59.046875-133.039062zm32.015625 193.964843c17.367187-9.109375 28.902344-25.8125 31.441406-44.925781h20.757813c-2.65625 10.246094-4.214844 20.933594-4.214844 32 0 11.0625 1.558594 21.75 4.214844 32h-52.207032zm-24 35.074219h81.40625c4.722656 11.609375 11.082031 22.367188 18.816406 32h-108.222656v-24c0-4.417969 3.585937-8 8-8zm-24 64v-8c0-4.417969 3.585937-8 8-8h131.609375c6.917969 6.085938 14.429688 11.503906 22.550781 16zm197.039063-3.417969-12.277344-42.964843 19.222656-25.617188h40l19.214844 25.625-12.277344 42.964844c-8.640625 2.144531-17.632812 3.410156-26.9375 3.410156s-18.296875-1.265625-26.945312-3.417969zm72.320312-6.277343 8.65625-30.304688h31.640625c-10.894531 12.933594-24.65625 23.34375-40.296875 30.304688zm0 0"
                  fill="url(#a)"
                />
              </svg>
            </ImageHeader>
            <Title>
              <FormattedMessage {...messages.title} />
            </Title>
            <StyledForm data-testid="add-league-form">
              <Field
                name="name"
                validate={required(intl)}
                error={errors.location && touched.location}
                component={TextInput}
                inputProps={{
                  "data-testid": "name",
                }}
                label={intl.formatMessage(messages.leagueName)}
              />
              <InputErrorMessage name="name" />
              <Field
                name="location"
                validate={required(intl)}
                error={errors.location && touched.location}
                component={TextInput}
                inputProps={{
                  "data-testid": "location",
                }}
                label={intl.formatMessage(messages.location)}
              />
              <InputErrorMessage name="location" />
              {/* <Field
                name="kindOfLeauge"
                validate={required(intl)}
                error={errors.location && touched.location}
                component={TextInput}
                inputProps={{
                  "data-testid": "location"
                }}
                label={intl.formatMessage(messages.kindOfLeague)}
              />
              <InputErrorMessage name="location" /> */}

              <FormControl
                variant="outlined"
                required
                className={classes.formControl}
              >
                <InputLabel
                  htmlFor="age-native-required"
                  style={{ paddingTop: 16 }}
                >
                  <FormattedMessage {...messages.kindOfLeague} />
                </InputLabel>
                <Select
                  native
                  value={kindOfLeague}
                  onChange={handleKindOfLeagueChange}
                  name="age"
                  inputProps={{
                    id: "age-native-required",
                  }}
                >
                  <option value="" />
                  <option value={"kids"}>Kids</option>
                  <option value={"amateur"}>Amateur</option>
                  <option value={"profesional"}>Profesional</option>
                </Select>
                {/* <FormHelperText>Required</FormHelperText> */}
              </FormControl>
              <FormControl
                variant="outlined"
                required
                className={classes.formControl}
              >
                <InputLabel
                  htmlFor="age-native-required"
                  style={{ paddingTop: 16 }}
                >
                  <FormattedMessage {...messages.NumberOfPartsGame} />
                </InputLabel>
                <Select
                  native
                  value={partsInAGame}
                  onChange={handlePartsInAGameChange}
                  name="partsGame"
                  inputProps={{
                    id: "age-native-required",
                  }}
                >
                  <option value="" />
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={4}>4</option>
                </Select>
                {/* <FormHelperText>Required</FormHelperText> */}
              </FormControl>

              {/* <TeamsSelect
                teams={teams}
                value={teamOption}
                onChange={(event: any) => {
                  setTeamOption(event.target.value);
                  setFieldValue("homeTeam", event.target.value);
                }}
              />
              <InputErrorMessage name="homeTeam" /> */}
              {/* <Field
                name="awayTeam"
                validate={required(intl)}
                error={errors.awayTeam && touched.awayTeam}
                component={TextInput}
                inputProps={{
                  "data-testid": "awayTeam"
                }}
                label={intl.formatMessage(messages.awayTeam)}
              />
              <InputErrorMessage name="awayTeam" /> */}

              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="date-picker-dialog"
                  label={intl.formatMessage(messages.leagueStartDate)}
                  format="yyyy-MM-dd"
                  value={selectedDate}
                  onChange={(date: any) => {
                    handleDateChange(date);
                    setFieldValue(
                      "startDate",
                      moment(date).format("YYYY-MM-DD")
                    );
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>

              <div style={{ marginTop: 16 }}>
                <Button
                  color="primary"
                  size="medium"
                  type="submit"
                  data-testid="go-next-button"
                  disabled={!isValid}
                >
                  {intl.formatMessage(messages.next)}
                </Button>
              </div>
            </StyledForm>
          </>
        );
      }}
    />
  );
};

export default injectIntl(NewTeamForm);
